// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___3nrRK","container":"styles__container___3Bstd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Configuration/styles.scss
// module id = 969
// module chunks = 0